module.exports = __webpack_public_path__ + "img/shoot_00016.37e4e358.png";